"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");
















































































































































var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import draggable from 'vuedraggable'
var _default = { components: {// draggable
  }, data: function data() {var h = this.$createElement;return { tableData: [], // 列表数据
      droplist: [], transferId: '', typeCode: '', list: [], // 穿梭框表一
      list2: [], // 穿梭框表二
      instructData: [], // 未关联指令列表
      instructRelData: [], // 已关联指令列表
      renderFunc: function renderFunc(h, option) {return h("span", [option.key, " - ", option.label]);}, searchData: { name: '', typeCode: '', terminal: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, transferData: { page: 1, // 当前页码
        rows: 10 // 页码条数
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, newadd: false, newadd2: false, title: '新增', addData: { id: '', name: '', sortNum: '', terminal: '', typeCode: '', isEnabled: true, programInfos: [] }, defaultData: { id: '', name: '', sortNum: '', terminal: '', typeCode: '', isEnabled: true, programInfos: [] }, tableColumns: [{ prop: 'name', label: '程序类型名称', isShow: true }, { prop: 'typeCode', label: '设备类型', isShow: true }, { prop: 'terminal', label: '终端', formatter: _formatter.terminalFormatter, isShow: true }, { prop: 'sortNum', label: '排序', isShow: true }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter, isShow: false }], rules: { name: [{ required: true, message: '请输入程序类型名称', trigger: 'blur' }], sortNum: [{ required: true, message: '请输入排序', trigger: 'blur' }], typeCode: [{ required: true, message: '请选择设备类型', trigger: 'blur' }], terminal: [{ required: true, message: '请选择终端', trigger: 'blur' }] } };}, mounted: function mounted() {var self = this;self.init();self.getdrop();}, methods: { init: function init() {var self = this;self.getData('/api/faProgramType/', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, resetFun: function resetFun() {// 重置
      this.searchData.name = '';this.searchData.typeCode = '';this.searchData.terminal = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, handleSizeChange2: function handleSizeChange2(val) {// 分页条数
      this.transferData.rows = val;this.transferData.page = 1;this.transferFun();}, handleCurrentChange2: function handleCurrentChange2(val) {// 分页页码
      this.transferData.page = val;this.transferFun();}, delMenu: function delMenu(item) {console.log(item);var self = this;self.$confirm('确定删除该记录吗？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(function () {
        self.delData('/api/faProgramType/del/' + item.id, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.newadd = true;
    },
    closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();
      done();
    },
    closeRefund2: function closeRefund2(done) {
      this.$refs['addForm2'].resetFields();
      this.typeCode = '';
      done();
    },
    onSubmit: function onSubmit() {
      var self = this;
      if (self.addData.sortNum) {
        if (!/^[0-9]*$/.test(self.addData.sortNum)) {
          self.$message({
            showClose: true,
            message: '排序号有误，请重填',
            type: 'error' });

          self.addData.sortNum = '';
          return false;
        }
      }
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/faProgramType', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },

    updateMenu: function updateMenu(item) {
      this.title = '编辑';
      var self = this;
      self.addData = {
        id: item.id,
        name: item.name,
        sortNum: item.sortNum,
        terminal: item.terminal,
        typeCode: item.typeCode };

      console.log('item', item.terminal);
      if (item.terminal === '1') {
        self.addData.terminal = 'pad';
      } else if (item.terminal === '2') {
        self.addData.terminal = 'phone';
        console.log('terminal', self.addData.terminal);
      }
      self.newadd = true;
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          if (self.addData.terminal === 'pad') {
            self.addData.terminal = '1';
          } else if (self.addData.terminal === 'phone') {
            self.addData.terminal = '2';
          }
          console.log(self.addData.terminal);
          self.postData('/api/faProgramType', self.addData, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    onCencal: function onCencal() {
      this.newadd = false;
      this.$refs['addForm'].resetFields();
    },
    onCencal2: function onCencal2() {
      this.newadd2 = false;
      this.$refs['addForm2'].resetFields();
      this.typeCode = '';
    },
    changeisForceFun: function changeisForceFun(val) {
      var self = this;
      self.searchData.terminal = '';
      if (val === '1') {
        self.searchData.terminal = '1';
      } else if (val === '2') {
        self.searchData.terminal = '2';
      }
    },
    changeisForceFun2: function changeisForceFun2(val) {
      var self = this;
      self.addData.terminal = '';
      if (val === '1') {
        self.addData.terminal = '1';
      } else if (val === '2') {
        self.addData.terminal = '2';
      }
    },
    getdrop: function getdrop() {
      var self = this;
      self.getData('/api/faDeviceType/getDownList', {}, function (res) {
        self.droplist = res;
      });
    },
    handleChange: function handleChange(value, direction, movedKeys) {
      var self = this;
      var reqData = [];
      for (var i = 0; i < self.instructRelData.length; i++) {
        var key = self.instructRelData[i];
        var insRel = self.list[key];
        reqData.push({
          id: insRel.id,
          sortNum: insRel.sortNum });

      }
      self.putData('/api/relateProgramType', {
        programInfos: reqData,
        typeId: self.transferId },
      function (res) {
        self.$message({
          message: '保存成功!',
          type: 'success' });

      });
    },
    transferFun: function transferFun(item) {
      this.title = '关联指令';
      var self = this;
      // console.log('item', item)
      // 获取所有指令列表
      self.getData('/api/faProgram/', {
        typeCode: item.typeCode,
        // rows: self.transferData.rows,
        // page: self.transferData.page
        rows: 99999,
        page: 1 },
      function (res) {
        self.list = res.list;
        self.pageData.page = res.pageNum;
        self.pageData.total = res.total;
        for (var i = 0; i < self.list.length; i++) {
          self.list[i] = {
            key: i,
            label: '指令:' + self.list[i].name + '|id:' + self.list[i].id,
            id: self.list[i].id,
            programName: self.list[i].name,
            sortNum: i,
            typeCode: self.list[i].typeCode,
            programId: self.list[i].id };

        }
        self.instructRelData = [];
        // 获取已关联的指令
        self.getData('/api/relateProgramType/' + item.id, {}, function (res) {
          self.list2 = res;
          self.transferId = item.id;
          for (var _i = 0; _i < self.list.length; _i++) {
            var ins = self.list[_i];
            for (var j = 0; j < self.list2.length; j++) {
              var insRel = self.list2[j];
              if (ins.id === insRel.programId) {
                self.instructRelData.push(ins.key);
                // self.instructData.splice(ins, 1) //不需要删除
              }
            }
          }
          self.instructData = self.list;
        });
      });

      self.newadd2 = true;
    } } };exports.default = _default;